module.exports = __webpack_public_path__ + "img/logo-dark.3474122c.svg";